import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { articles, conversaciones } from "@/data/content";
import PageHeader from "@/components/site/PageHeader";
import { Reveal } from "@/components/site/Reveal";
import BookCTA from "@/components/site/BookCTA";

export default function Cuaderno() {
  const published = articles.filter((a) => a.published);
  const upcoming = articles.filter((a) => !a.published);

  return (
    <div data-testid="cuaderno-page">
      <PageHeader
        overline="Cuaderno"
        titleLines={["Reflexiones sobre", "la escucha y", "la palabra"]}
        intro="Notas sobre la escucha, la palabra y la experiencia humana."
      />

      {/* Published articles */}
      <section className="max-w-[1400px] mx-auto px-5 md:px-10 pb-16">
        <div className="border-t border-black/10">
          {published.map((a, i) => (
            <Reveal key={a.slug} delay={i * 0.06}>
              <Link
                to={`/cuaderno/${a.slug}`}
                data-testid={`article-link-${a.slug}`}
                className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 items-start py-10 md:py-14 border-b border-black/10"
              >
                <span className="md:col-span-1 overline">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="md:col-span-8">
                  <h2 className="font-display text-3xl md:text-5xl tracking-tight leading-[1.05] group-hover:text-[#9C5A4B] transition-colors duration-300">
                    {a.title}
                  </h2>
                  <p className="mt-4 text-[#5c5c5c] text-lg max-w-2xl leading-relaxed">
                    {a.excerpt}
                  </p>
                </div>
                <span className="md:col-span-3 md:text-right flex items-center md:justify-end gap-2 text-sm tracking-wide text-[#9C5A4B]">
                  Leer
                  <ArrowRight
                    size={16}
                    className="transition-transform duration-300 group-hover:translate-x-1"
                  />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Upcoming */}
      <section className="max-w-[1400px] mx-auto px-5 md:px-10 pb-24 md:pb-32">
        <Reveal>
          <p className="overline mb-8">Próximamente</p>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6">
          {upcoming.map((a, i) => (
            <Reveal key={a.slug} delay={i * 0.05}>
              <div className="flex items-baseline justify-between gap-4 py-5 border-b border-black/10 opacity-50">
                <div>
                  <h3 className="font-display text-xl md:text-2xl tracking-tight">
                    {a.title}
                  </h3>
                  <p className="text-sm text-[#5c5c5c] mt-1">{a.excerpt}</p>
                </div>
                <span className="text-xs tracking-widest uppercase whitespace-nowrap">
                  Próximamente
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Conversaciones */}
      <section className="bg-[#efece5]" data-testid="conversaciones-section">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-20 md:py-28">
          <Reveal>
            <p className="overline mb-6">{conversaciones.title}</p>
            <p className="font-display text-3xl md:text-4xl tracking-tight max-w-2xl mb-10">
              {conversaciones.intro}
            </p>
          </Reveal>
          <div className="flex flex-wrap gap-3">
            {conversaciones.items.map((c, i) => (
              <Reveal key={c} delay={i * 0.05}>
                <span className="inline-block border border-black/15 rounded-full px-6 py-2.5 text-sm text-[#1a1a1a]/70">
                  {c}
                </span>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <BookCTA />
    </div>
  );
}
